import Axios from "axios";
import {
  GAMES_LIST_SUCCESS,
  GAMES_INFO_SUCCESS,
  GAMES_FILTER_HANDLING,
  GAMES_SEARCH_NAME,
  GAMES_CATEGORY_SUCCESS,
  CLEAR_GAMES_INFO,
  GAMES_CATEGORY_INFO,
  IP_ADDRESS_INFO,
  VISITOR_VIEW_SUCCESS,
  VISITOR_GAME_SUCCESS,
} from "../actionTypes/games";
import {
  ON_SHOW_MESSAGE,
  INIT_URL,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  HIDE_DIALOG,
} from "../actionTypes/common";
// import AllDataService from '../services/all.service';

import axiosHttp from "../services/axiosCommon";

export const visitorView = (infoData) => async (dispatch) => {
  console.log({ infoData }, "------------");
  try {
    const result = await axiosHttp.put("/visitor/visit/view", infoData);
    const { data } = result;
    if (data.error) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      dispatch({
        type: VISITOR_VIEW_SUCCESS,
        payload: data,
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    dispatch({
      type: ON_SHOW_MESSAGE,
      payload: { memberMessage: "Some error has occurred", status: 500, error: true },
    });

    return Promise.reject(err);
  }
};
export const visitorGame = (infoData) => async (dispatch) => {
  console.log({ infoData }, "------------");
  try {
    const result = await axiosHttp.put("/visitor/visit/game", infoData);
    const { data } = result;
    if (data.error) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      dispatch({
        type: VISITOR_VIEW_SUCCESS,
        payload: data,
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    dispatch({
      type: ON_SHOW_MESSAGE,
      payload: { memberMessage: "Some error has occurred", status: 500, error: true },
    });

    return Promise.reject(err);
  }
};
export const ipAddress = () => async (dispatch) => {
  try {
    const result = await axiosHttp.get("https://ipapi.co/json");
    const { data } = result;
    if (data.error && data.status !== 200) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      dispatch({
        type: IP_ADDRESS_INFO,
        payload: { ...data },
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    dispatch({
      type: ON_SHOW_MESSAGE,
      payload: {
        userMessage: "Some error has occurred",
        status: 500,
        error: true,
      },
    });
    return Promise.reject(err);
  }
};

export const getGamesCategoryInfo = (info) => async (dispatch) => {
  dispatch({
    type: GAMES_CATEGORY_INFO,
    payload: info,
  });
};

export const getGamesList = (queryInfo) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.get("/web/games", {
      params: queryInfo,
    });
    const { data } = result;
    if (data.error && data.status !== 200) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      // dispatch({
      //   type: INIT_URL,
      //   payload: "/gamess/list",
      // });
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      dispatch({
        type: GAMES_LIST_SUCCESS,
        payload: { ...data, queryInfo },
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    dispatch({
      type: ON_SHOW_MESSAGE,
      payload: {
        userMessage: "Some error has occurred",
        status: 500,
        error: true,
      },
    });
    return Promise.reject(err);
  }
};
export const getGamesInfo = (paramsObj) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.get("/games/info", {
      params: paramsObj,
    });
    const { data } = result;
    if (data.error) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      dispatch({
        type: ON_HIDE_LOADER,
      });
      dispatch({
        type: GAMES_INFO_SUCCESS,
        payload: data,
      });

      dispatch({
        type: GAMES_CATEGORY_SUCCESS,
        payload: data.categories,
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    dispatch({
      type: ON_SHOW_MESSAGE,
      payload: {
        userMessage: "Some error has occurred",
        status: 500,
        error: true,
      },
    });
    return Promise.reject(err);
  }
};

export const onChangeSearchName = (info) => async (dispatch) => {
  dispatch({
    type: GAMES_SEARCH_NAME,
    payload: info,
  });
};

export const onChangeFilterHandling = (info) => async (dispatch) => {
  dispatch({
    type: GAMES_FILTER_HANDLING,
    payload: info,
  });
};
export const clearGamesInfo = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GAMES_INFO,
  });
};
